export default __webpack_public_path__ + "static/media/cheque.382a9cef.svg";